import { useTheme } from '@mui/material/styles';

interface PropTypes {
    streetAddress: string;
    city: string;
    state: string;
    zip: string;
}

function GoogleMap(props: PropTypes): JSX.Element {
    const theme = useTheme();
    const encodedLocation = encodeURIComponent(`${props.streetAddress} ${props.city} ${props.state} ${props.zip}`);
    return (
      <iframe
        width="100%"
        height="100%"
        frameBorder="0"
        title="map"
        marginHeight={0}
        marginWidth={0}
        scrolling="no"
        src={`https://maps.google.com/maps?width=100%&height=100%&hl=en&q=${encodedLocation}&ie=UTF8&t=&z=14&iwloc=B&output=embed`}
        style={{
          minHeight: 300,
          filter:
            theme.palette.mode === 'dark'
              ? 'grayscale(0.5) opacity(0.7)'
              : 'none',
        }}
      />
    );
  }

  export default GoogleMap;